module.exports = __webpack_public_path__ + "img/interestsArea.ce129abf.svg";